export default __webpack_public_path__ + "static/media/carbon.67c188f3.svg";